<template>
  <div>
    <div class="mb-3">
      <b>Your Latest Scans</b>
      <span class="grey--text ml-2">({{ listMeta.total }})</span>
    </div>

    <b-card class="empty-container" v-if="listMeta.total === 0">
      Your scanned boards will appear here.
      <b-link class="font-weight-bold" @click="$emit('openScanner')"
        >Scan QR Code</b-link
      >
    </b-card>

    <div v-else>
      <!-- Shimmer Effect -->
      <!-- <div v-if="loading">
        <b-row :class="isMobile ? 'd-flex align-items-center flex-column' : ''">
          <b-col
            v-for="i in listLimit"
            :key="i"
            :style="
              isMobile
                ? 'min-width: 250px; max-width: 250px;'
                : 'min-width: 20%; max-width: 20%;'
            "
          >
            <card-shimmer :imageHead="false" :withTitle="true"></card-shimmer>
          </b-col>
        </b-row>
      </div>-->

      <b-row :class="isMobile ? 'd-flex align-items-center flex-column' : ''">
        <b-col
          v-for="board in list"
          :key="board.id"
          :style="
            isMobile
              ? 'min-width: 250px; max-width: 250px;'
              : 'min-width: 20%; max-width: 20%;'
          "
        >
          <board-item :board="board" />
        </b-col>
      </b-row>

      <div
        class="text-center"
        v-if="listMeta.current_page !== listMeta.last_page"
      >
        <b-button
          class="show-btn my-4"
          :class="isMobile ? 'w-100' : ''"
          @click="loadMore"
          >Show More</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import BoardItem from '@/components/cards/BoardItem'
// import CardShimmer from '@/components/shimmers/card'

export default {
  components: {
    BoardItem
    // CardShimmer
  },

  computed: {
    ...mapState({
      list: state => state.board.list,
      listMeta: state => state.board.listMeta
    }),

    listLimit() {
      return this.isMobile ? 5 : 10
    }
  },

  data() {
    return {
      loading: false,
      filters: {
        category_id: null,
        search: null,
        suburb: null,
        within_distance_to: null
      }
    }
  },

  methods: {
    ...mapActions({
      getBoards: 'board/getBoards'
    }),

    ...mapMutations({
      clearBoards: 'board/clearBoardList'
    }),

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchBoards(this.listMeta.current_page + 1)
      }
    },

    async fetchBoards(page = 1) {
      if (this.loading) return
      const params = {
        page: page,
        limit: this.listLimit,
        filters: this.filters
      }
      this.loading = true
      await this.getBoards(params)
      this.loading = false
    }
  },

  created() {
    this.clearBoards()
    this.fetchBoards()
  }
}
</script>

<style lang="scss" scoped>
.row {
  margin: 0 -10px;
}
.col {
  padding: 0 10px;
  margin-bottom: 20px;
}
.show-btn {
  background: #0000000d 0% 0% no-repeat padding-box;
  border-radius: 8px;
  color: black;
  border: none;
  width: 340px;
}
.empty-container {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border-radius: 10px;
  height: 240px;
  text-align: center;
  padding-top: 85px;
  box-shadow: none;
}
</style>
